import { Trans } from "react-i18next";

export default function AiChallengeFormatContent({ ownerChallenge, status }) {
  return (
    <Trans
      i18nKey={
        status === "success" ? "notifications.aiChallengeFormatSuccess"
        : status === "pending" ?
          "notifications.aiChallengeFormat"
        : "notifications.aiChallengeFormatFailed"
      }
      values={{ challenge: ownerChallenge?.name || "Deleted" }}
      components={{ b: <b /> }}
    />
  );
}
